import * as actionTypes from '../actions/types';

const initialState = {
    archivosSubidos: [],
    selectedFiles: undefined,
    progressInfos: [],
    fileInfos: [],
    uploading: false,
    subiendoNuevaInternacion: false,
    subiendoInternacionesMasivo: false,
    mostrarProcesarInternacion: false,
    habilitarCargaInternacion: false,
    cargaFinalizada: false,
    erroresArchivos: [],
    cantRespuestas: 0,
};

export function adjuntarArchivoReducer(state = initialState, action) {
    switch (action.type) {
        case actionTypes.ACTUALIZAR_ATRIBUTOS_ARCHIVOS:
            return {
                ...state,
                ...action.payload,
            };
        case actionTypes.SINCRONIZAR_INFORMACION_ARCHIVOS:
            return {
                ...state,
                fileInfos: [...action.payload],
                archivosSubidos: [],
            };
        case actionTypes.VACIAR_ARCHIVOS_SUBIDOS:
            return {
                ...state,
                archivosSubidos: [],
            };
        case actionTypes.ARCHIVOS_SELECCIONADOS:
            return {
                ...state,
                postsprogressInfos: [],
                selectedFiles: [...action.payload],
            };
        case actionTypes.ELIMINAR_ARCHIVO:
            const newFileInfo = [...state.fileInfos];
            newFileInfo.splice(action.payload, 1);
            return {
                ...state,
                fileInfos: newFileInfo,
            };
        case actionTypes.INICIALIZAR_BARRAS_PROCESO:
            const selectedFiles = state.selectedFiles;

            let _progressInfos = [];

            for (let i = 0; i < selectedFiles.length; i++) {
                _progressInfos.push({
                    percentage: 0,
                    fileName: selectedFiles[i].name,
                });
            }

            return {
                ...state,
                progressInfos: _progressInfos,
            };
        case actionTypes.ACTUALIZAR_BARRA_PROCESO:
            let progreso = [...state.progressInfos];

            progreso[action.payload.index].percentage = Math.round(
                (100 * action.payload.cargado) / action.payload.total
            );

            return {
                ...state,
                progressInfos: progreso,
            };
        case actionTypes.ACTUALIZAR_INFORMACION_ARCHIVOS:
            return {
                ...state,
                archivosSubidos: [...state.archivosSubidos, action.payload],
            };
        case actionTypes.SET_MOSTRAR_PROCESAR_INTERNACION:
            return {
                ...state,
                mostrarProcesarInternacion: action.payload,
            };
        case actionTypes.SET_CARGA_ARCHIVOS_INTERNACION:
            return {
                ...state,
                habilitarCargaInternacion: action.payload,
            };
        case actionTypes.SUMAR_RESPUESTA:
            return {
                ...state,
                cantRespuestas: state.cantRespuestas + 1,
            };
        default:
            return state;
    }
}
